// extracted by mini-css-extract-plugin
export var address = "style-module--address--B-sJ5";
export var desc = "style-module--desc--LmJXj";
export var divider = "style-module--divider--0P420";
export var dotsWrapper = "style-module--dotsWrapper--SrXNN";
export var gadgetPosition = "style-module--gadgetPosition--5VRAJ";
export var gadgetPosition2 = "style-module--gadgetPosition2--BL9dI";
export var header = "style-module--header--4WS9w";
export var imageWrapper = "style-module--imageWrapper--gmjAA";
export var mentorsCards = "style-module--mentorsCards--WtbFr";
export var name = "style-module--name--7Okr7";
export var root = "style-module--root--oXKXQ";
export var title = "style-module--title--w17o0";